// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1nBMs","footer":"ChangeClinic_footer__ql8ET"};